import React, { useState } from "react";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import styled from "styled-components";
import { usePreferences, ThemeProps } from "../usePreferences";

const StyledFormControl = styled(FormControl)`
  margin: 10px;

  min-width: 120px;
`;

type Props = {
  fieldName: string;
  value?: string;
  options: string[];
  onFieldChange(value: string): void;
};

type StyleProps = {
  isValid: Boolean;
} & ThemeProps;

const StyledPicker = styled(Select)`
  && {
    height: 50px;
    background: ${({ theme }: StyleProps) => theme.palette.background};
    color: ${({ theme }: StyleProps) => theme.palette.textColour};

    & fieldset {
      border-color: ${({ theme }: StyleProps) =>
        theme.palette.neutralActionColor} !important;
    }
    & .Mui-focused {
      color: ${({ theme }: StyleProps) => theme.palette.textColour}!important;
    }
  }
`;

export const PickerEntry = ({
  options,
  onFieldChange,
  fieldName,
  value
}: Props) => {
  const [selectedOption, setSelectedOption] = useState(value || "");
  const [preferences, _dispatch] = usePreferences();
  const onValueChange = (newValue: string) => {
    setSelectedOption(newValue);
    onFieldChange(newValue);
  };
  return (
    <StyledFormControl variant="outlined">
      <InputLabel>{fieldName}</InputLabel>
      <StyledPicker
        theme={preferences.theme}
        labelId="picker"
        id="picker"
        labelWidth={40}
        value={selectedOption}
        onChange={(event: React.ChangeEvent<any>) =>
          onValueChange(event && event.target && event.target.value)
        }
        isValid={true}
      >
        {options.map((option, index) => (
          <MenuItem key={index} value={option}>
            {option}
          </MenuItem>
        ))}
      </StyledPicker>
    </StyledFormControl>
  );
};
